module.exports = __webpack_public_path__ + "img/elegant.ce73229.jpg";